export default __webpack_public_path__ + "static/skills-tag-neutral-dark-e09f88966d16dc14f2f9faa7725f052af954572f184a432a90cb48dbe40ce870.png";